export var assign_group = "\n#ifdef dGeoTexture\n    float group = decodeFloatRGB(readFromTexture(tGroup, VertexID, uGeoTexDim).rgb);\n#else\n    float group = aGroup;\n#endif\n";
//# sourceMappingURL=assign-group.glsl.js.map